import { useRequestGetVerificationPhotos } from '@/hooks/httpRequest';
import { VerificationAdditionalCheckStatusEnum } from '@/enums';
import useUrlParams from './useUrlParams';

const useVerifications = () => {

  const { gender } = useUrlParams();
  const result = useRequestGetVerificationPhotos(
    {
      gender,
      additionalCheckStatus: VerificationAdditionalCheckStatusEnum.WITHOUT_STATE
    },
    !!gender
  );

  return result;

};

export default useVerifications;
